import axios from 'axios';
import { API_URL, API_KEY, ESAAD_CARD_API_URL } from 'constants';

const defaultHeaders = {
  'Content-Type': 'application/json',
  accept: 'application/json'
};

const headers = {
  ...defaultHeaders,
  api_key: API_KEY,
  storeid: 'mafuae'
};

const axiosObj = axios.create({
  baseURL: API_URL,
  headers
});

const esaadCardAxiosObj = axios.create({
  baseURL: `${ESAAD_CARD_API_URL}/v2/customers`,
  headers: {
    ...defaultHeaders,
    channelid: 'esaad-link-portal'
  }
});

export const saveEmpData = (partnerCode, requestData) => {
  return axiosObj.post(`/${partnerCode}/link-customer`, requestData);
};

export const saveEsaadCardData = (shareId, token, data) => {
  esaadCardAxiosObj.defaults.headers = {
    ...esaadCardAxiosObj.defaults.headers,
    appId: 'Reactweb',
    env: 'UAT2',
    langCode: 'en',
    storeId: 'mafuae',
    Authorization: `Bearer ${token}`
  };
  return esaadCardAxiosObj.post(`/loyalty/${shareId}/link-esaad-card`, data);
};


export const verifyOTP = (referenceId, token, data) => {
  esaadCardAxiosObj.defaults.headers = {
    ...esaadCardAxiosObj.defaults.headers,
    appId: 'Reactweb',
    env: 'UAT2',
    langCode: 'en',
    storeId: 'mafuae',
    Authorization: `Bearer ${token}`
  };
  return esaadCardAxiosObj.post(`/otp/verification/${referenceId}`, data);
};
